/** Слова и склонения рабочего места «Тесты»: единый источник текстов (макет v6). */

export function plural(n: number, one: string, few: string, many: string): string {
  const hundreds = Math.abs(n) % 100;
  const units = hundreds % 10;
  if (hundreds > 10 && hundreds < 20) return many;
  if (units > 1 && units < 5) return few;
  if (units === 1) return one;
  return many;
}

export const num = (n: number, one: string, few: string, many: string): string =>
  `${n} ${plural(n, one, few, many)}`;

export const questionsLabel = (n: number): string => num(n, 'вопрос', 'вопроса', 'вопросов');
export const minutesLabel = (n: number): string => num(n, 'минута', 'минуты', 'минут');
export const peopleLabel = (n: number): string => num(n, 'человек', 'человека', 'человек');
/** Родительный падеж после «для»: «для 1 человека», «для 2 человек», «для 5 человек». */
export const peopleFor = (n: number): string => num(n, 'человека', 'человек', 'человек');
export const testsIn = (n: number): string => num(n, 'тесте', 'тестах', 'тестах');

export const QUESTION_TYPE_LABEL: Record<string, string> = {
  single_choice: 'Один правильный ответ',
  multiple_choice: 'Несколько правильных ответов',
  open_answer: 'Ответ своими словами',
  matching: 'Найти пары',
  image_identification: 'Узнать деталь по фото',
};

export const questionTypeLabel = (type: string): string => QUESTION_TYPE_LABEL[type] ?? 'Вопрос';
